import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EmptyState from "../../../../components/EmptyState";
import { SectionLoader } from "../../../../components/PageLoader";
import { getTransactions } from "../../../../redux/actions/walletActions";
import moment from "moment";

const TransactionHistory = () => {
  const dispatch = useDispatch();
  const [page] = useState(1);
  const [loading, setLoading] = useState(false);

  const { transactions } = useSelector((state) => state.wallet);
  let items = [];
  if (Array.isArray(transactions)) {
    items = Array.isArray(transactions[0]) ? transactions[0] : transactions;
  } else if (transactions && Array.isArray(transactions["0"])) {
    items = transactions["0"]; // handle { "0": [...], total_item_count }
  }

  

  useEffect(() => {
    setLoading(true);
  
    Promise.resolve(getTransactions(dispatch, page)).finally(() =>
      setLoading(false)
    );
  }, [dispatch, page]);

  
  return (
    <>
      {loading && <SectionLoader />}
      {!loading && items.length === 0 && (
        <EmptyState text="No transaction found" />
      )}
      <div className="history d-flex flex-column">
        {!loading &&
          items.length > 0 &&
          items.map((transaction) => (
            <div
              key={transaction.id}
              className={`${transaction.transactionType} d-flex align-items-center justify-content-between m-4`}
            >
              <div className="d-flex align-items-center">
                <span className="indicator mr-4">
                  {transaction.transactionType === "credit" ? "+" : "-"}
                </span>
                <div className="d-flex flex-column">
                  <span>{transaction.description}</span>
                  <span className="text-muted">
                    {moment(transaction.date_created).format(
                      "Do MMM YYYY; h:mm a"
                    )}
                  </span>
                </div>
              </div>
              <span className="mr-2">
                <b>{`${transaction.amount} ${transaction.currency}`}</b>
              </span>
            </div>
          ))}
      </div>
    </>
  );
};

export default TransactionHistory;
